import Success from 'assets/images/success.svg';
import Error from 'assets/images/error.svg';
import Theme from 'styles/theme';

export const statusStrategy = {
  success: {
    icon: Success,
    alt: 'success',
    message: 'Good News!',
    color: Theme.PRIMARY_COLOR
  },
  error: {
    icon: Error,
    alt: 'error',
    message: 'Adjust Cost and/or Revenue and Try Again',
    color: Theme.ERROR
  }
};

const investment = (jobs) => {
  let result = Math.floor(jobs/10) * 900000;
  return new Intl.NumberFormat().format(result)
}

export const detailsStrategy = {
  success: (jobs) => `
  <p>Your project creates <b>${jobs} EB-5 eligible jobs.</b></p><br/>
  <p>Therefore, your project is eligible for at least <b>$${investment(jobs)} in capital investment</b> from qualified EB-5 investors.</p><br/>
  <p>Submit your information below to receive additional information regarding your project’s job creation, and to get started immediately with the EB-5 process.</p>`,
  error: () => 'Sorry your project does not create at least 10 EB-5 eligible jobs. Please adjust the project cost and/or revenue fields and try again.'
}
